import { render, staticRenderFns } from "./AsociarTiposActividad.vue?vue&type=template&id=234ffd45&"
import script from "./AsociarTiposActividad.vue?vue&type=script&lang=ts&"
export * from "./AsociarTiposActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('234ffd45', component.options)
    } else {
      api.reload('234ffd45', component.options)
    }
    module.hot.accept("./AsociarTiposActividad.vue?vue&type=template&id=234ffd45&", function () {
      api.rerender('234ffd45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/crud/crear/AsociarTiposActividad.vue"
export default component.exports